import { useContext } from 'react';
import { RoutesStore } from '../context';

export function useNextApplicationPath() {
  const { nextRoute } = useContext(RoutesStore);
  return nextRoute?.path;
}
